






























import { Component } from "../../../Infrastructure/CorBase/CoreBase";
import PricelistListBase from "./PricelistListBase";

@Component
export default class pricelistList extends PricelistListBase {
    created() {
        super.initializeRights('ACC_Pricelist_Update', 'ACC_Pricelist_Update', 'ACC_Pricelist_Update', 'ACC_Pricelist_Update');
        super.setDetailName('PricelistDetail');
        this.loadSpecFilters();
        this.createdBase();
        super.created();

    }

    selectRows(items: any) {
        super.selectRows(items);
    }

    isSuperUserAllow() {
        return this.isSuperUser;
    }


    showAllertToDeleteClick(itemsSelected: any) {
        this.showAlertBeforeDeleteBase(itemsSelected);
    }


    loadFilters(value: any) { super.loadFilters(value); }
    //createNewClick(elementId: any) { super.createNewClick(elementId); }
    createNewClick(elementId: any) { this.createPricelists(); }
    detailClick(elementId: any) { super.detailClick(elementId); }
    deleteClick(elementId: any) { this.deleteClick(elementId) }
};
